import { useState } from "react";
import { useMutation } from "@tanstack/react-query";

import { api } from "../api/client";
import type { MeResponse } from "../api/me";

export default function DeleteAccountSection({ me }: { me: MeResponse }) {
  const [open, setOpen] = useState(false);
  const [confirmText, setConfirmText] = useState("");
  const email = me.email ?? "";

  const del = useMutation({
    mutationFn: async () => {
      await api.delete("/me");
    },
    onSuccess: () => {
      window.location.href = "/login";
    },
  });

  const matches = confirmText.trim().toLowerCase() === email.toLowerCase() && email.length > 0;

  return (
    <section className="mt-6 rounded-2xl border border-rose-900/50 bg-rose-950/20 p-5">
      <h2 className="mb-1 text-base font-semibold text-rose-200">Delete account</h2>
      <p className="mb-4 text-sm text-rose-200/70">
        Permanently removes your watchlists, analyses, notification preferences, and Telegram pairing.
        Backups are retained for up to 30 days. This cannot be undone from the app.
      </p>

      {!open ? (
        <button
          onClick={() => setOpen(true)}
          className="rounded-lg border border-rose-800 px-3 py-2 text-sm text-rose-200 transition hover:bg-rose-900/40"
        >
          Delete my account…
        </button>
      ) : (
        <div className="space-y-3">
          <p className="text-sm text-rose-200">
            Type <span className="font-mono text-rose-100">{email}</span> to confirm.
          </p>
          <input
            type="email"
            autoComplete="off"
            value={confirmText}
            onChange={(e) => setConfirmText(e.target.value)}
            placeholder={email}
            className="w-full rounded-lg border border-rose-900 bg-slate-950 px-3 py-2 font-mono text-sm text-rose-100 placeholder:text-rose-900 focus:border-rose-700 focus:outline-none"
          />
          <div className="flex flex-wrap gap-2">
            <button
              onClick={() => {
                setOpen(false);
                setConfirmText("");
              }}
              disabled={del.isPending}
              className="rounded-lg border border-slate-700 px-3 py-2 text-sm text-slate-200 transition hover:bg-slate-800 disabled:opacity-50"
            >
              Cancel
            </button>
            <button
              onClick={() => del.mutate()}
              disabled={!matches || del.isPending}
              className="rounded-lg bg-rose-600 px-3 py-2 text-sm font-medium text-white shadow-sm transition hover:bg-rose-500 disabled:cursor-not-allowed disabled:opacity-50"
            >
              {del.isPending ? "Deleting…" : "Delete forever"}
            </button>
          </div>
          {del.isError && (
            <p className="text-xs text-rose-300">
              Failed: {(del.error as Error).message}. Try again or email mehdi.towhidi@gmail.com.
            </p>
          )}
        </div>
      )}
    </section>
  );
}
